// extracted by mini-css-extract-plugin
module.exports = {"quoteBlock":"Quote_quoteBlock__iucyn","quote":"Quote_quote__1xSut","quoteAuthor":"Quote_quoteAuthor__UEILU","hide":"Quote_hide__QjH3_"};